import { render, staticRenderFns } from "./RegionDetail.vue?vue&type=template&id=7555b1fb&scoped=true"
import script from "./RegionDetail.vue?vue&type=script&lang=js"
export * from "./RegionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555b1fb",
  null
  
)

export default component.exports